import { Box, BoxProps, CircularProgressProps } from '@mui/material'
import React from 'react'
import { Flex } from 'src/styles/flexComponent'
import Circle from '../assets/circle.svg'

export const Spinner: React.FC<CircularProgressProps> = props => {
  return <img src={Circle} className="spinner" style={{ height: props.size, width: props.size }} />
}

export const FlexSpinner: React.FC<CircularProgressProps> = props => {
  return (
    <Flex.Row justifyContent="center" flex={1}>
      <img src={Circle} className="spinner" style={{ height: props.size, width: props.size }} />
    </Flex.Row>
  )
}

interface CenteredSpinnerProps extends CircularProgressProps {
  containerProps?: BoxProps
  height?: number | string
}

export const CenteredSpinner: React.FC<CenteredSpinnerProps> = ({ containerProps, height, ...props }) => {
  return (
    <Box
      className={`flex items-center justify-center ${!height ? 'min-h-screen' : ''}`}
      minWidth="100%"
      {...containerProps}
      height={height}
    >
      <Spinner {...props} />
    </Box>
  )
}

export const DialogSpinner: React.FC<CircularProgressProps> = props => {
  return (
    <Box
      className="fixed inset-0 flex items-center justify-center w-full h-full"
      sx={{
        backgroundColor: 'rgba(0,0,0,0.2)',
        zIndex: 1300,
      }}
    >
      <Spinner {...props} />
    </Box>
  )
}
